// removed by extract-text-webpack-plugin
module.exports = {"label":"PaginationNavigation-hashed__label__1Y4PG","rate":"PaginationNavigation-hashed__rate__1KTPW","container":"PaginationNavigation-hashed__container__1qHZS","button":"PaginationNavigation-hashed__button__1kcSZ","previous":"PaginationNavigation-hashed__previous__3_lbI","next":"PaginationNavigation-hashed__next__26V_S"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/pagination/PaginationNavigation/PaginationNavigation-hashed.scss
// module id = 1198
// module chunks = 0